import * as React from 'react';
import { DividerProps } from './DividerTypes';
import styles from './divider.module.scss';

export const Divider = ({
  color = '$color-secondary-a4',
  mBottom = 'xsmall',
  mTop = 'xsmall',
  mLeft = 'xxsmall',
  mRight = 'xxsmall',
  mHorizontal,
  mVertical,
  orientation = 'horizontal',
  size = 'auto',
}: DividerProps) => {
  const dividerColor = styles[`${color.replace('$', '')}`];

  const dividerClasses = [
    styles['bsw-divider'],
    mBottom && !mVertical ? styles[`bsw-mBottom--${mBottom}`] : '',
    mTop && !mVertical ? styles[`bsw-mTop--${mTop}`] : '',
    mLeft && !mHorizontal ? styles[`bsw-mLeft--${mLeft}`] : '',
    mRight && !mHorizontal ? styles[`bsw-mRight--${mRight}`] : '',
    mHorizontal ? styles[`bsw-mHorizontal--${mHorizontal}`] : '',
    mVertical ? styles[`bsw-mVertical--${mVertical}`] : '',
    orientation === 'horizontal' ? styles['horizontal'] : styles['vertical'],
    styles[`${orientation}--${size}`],
  ].join(' ');

  return (
    <div
      className={dividerClasses}
      style={{ backgroundColor: dividerColor }}
    />
  );
};
